export default "https://assets.egbcdn.net/assets/packs/_/images/registration/registration_ru-68c80ac53d5c2b8ee36f8879b6f3e983.jpg";